import React from "react";
import { ProfileContainer } from "./style";
import Profile from "components/profile";
const ProfilePage = () => {
  return (
    <ProfileContainer>
      <div className="letter">
        در این بخش می توانید اطلاعات هویتی خود را تکمیل و در صورت لزوم ویرایش
        نمایید.
        <br />
        توجه داشته باشید اطلاعات درج شده توسط شما در این بخش، مبنای قرارداد خرید
        خواهد بود، لذا خواهشمند است بمنظور جلوگیری از بروز هرگونه مشکل احتمالی
        در آینده، پس از تکمیل دقیق فرم، تمامی اطلاعات وارده را مجددا بررسی نموده
        و از صحت آن اطمینان حاصل فرمایید.
        <br />
        لازم به ذکر است در صورت عدم تکمیل تمامی اطلاعات ذکر شده در پروفایل، پیش
        از پرداخت اینترنتی وجه، نماد "اطلاعات ضروری" مجددا به نمایش در خواهد
        آمد.
        <br />
        جهت تسریع فرایند خرید در زمان مقرر، پیشنهاد میشود کلیه اطلاعات شخصی خود
        را از قبل تکمیل نمایید تا به هنگام خرید، در کمترین زمان ممکن به درگاه
        پرداخت متصل گردید.
        <br />
        مستحضر باشید، مبنای خرید نهایی از نظر شرکت، رسید قابل چاپ پرداخت
        اینترنتی است که پس از واریز وجه و بازگشت به وبسایت فروش، قابل نمایش
        خواهد بود.
        <br />
        از آنجا که بدلیل تقاضای بالای خرید و ترافیک سایت، بروز اختلال و کندی
        سرعت قابل پیشبینی و اجتناب ناپذیر است پیشاپیش از شکیبایی شما عزیزان
        سپاسگزاریم.
        <br />
        لازم به یاداوری است؛ تیپ، آپشن و تریم داخلی خودرو در زمان صدور دعوتنامه
        تعیین خواهد شد.
        <br />
        شرکت آرینا درایو ضمن تشکر از شما به جهت انتخاب خودرو آرینا درایو، تجربه
        خرید بسیار خوبی را برایتان آرزومند است.
      </div>
      <Profile />
    </ProfileContainer>
  );
};
export default ProfilePage;
